import { SUB_TIER_DISPLAY_STATUS, type SubTierDisplayStatus } from "./constant";

export type { SubTierDisplayStatus };

export type LevelGoal = {
    title: string;
    completed: boolean;
};

export type SubTier = {
    sub_tier: number;
    label: string;
    xp_min?: number | null;
    xp_max?: number | null;
    uncapped?: boolean;
    is_current?: boolean;
    is_completed?: boolean;
    level_goals?: LevelGoal[] | null;
};

type Tier = {
    tier: number;
    name: string;
    sub_tiers?: SubTier[] | null;
};

export type TierProgressData = {
    current_tier?: number;
    current_sub_tier?: number;
    tiers?: Tier[];
};

export function formatXpRange(xpMin?: number | null, xpMax?: number | null): string {
    if (xpMin == null && xpMax == null) {
        return "--";
    }

    if (xpMax == null) {
        return `${xpMin}+`;
    }

    if (xpMin == null) {
        return String(xpMax);
    }

    return `${xpMin}-${xpMax}`;
}

export function getSubTierDisplayStatus(
    tierNumber: number,
    subTierNumber: number,
    currentTier?: number,
    currentSubTier?: number,
    isCompleted?: boolean,
): SubTierDisplayStatus {
    if (currentTier == null || currentSubTier == null) {
        return SUB_TIER_DISPLAY_STATUS.LOCKED;
    }

    if (tierNumber > currentTier) {
        return SUB_TIER_DISPLAY_STATUS.LOCKED;
    }

    if (tierNumber < currentTier) {
        return SUB_TIER_DISPLAY_STATUS.COMPLETED;
    }

    if (subTierNumber > currentSubTier) {
        return SUB_TIER_DISPLAY_STATUS.LOCKED;
    }

    if (subTierNumber < currentSubTier) {
        return SUB_TIER_DISPLAY_STATUS.COMPLETED;
    }

    if (isCompleted) {
        return SUB_TIER_DISPLAY_STATUS.COMPLETED;
    }

    return SUB_TIER_DISPLAY_STATUS.CURRENT;
}
